"use client";

import React from "react";
import { Radio, Play, Headphones, Clock, Disc3, Volume2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const scheduleData = [{
  id: 1,
  time: "AVAILABLE NOW",
  dj: "Dr. Aris Thorne",
  show: "1-on-1 Intensive",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680106/img/instructor_aris.png",
  isLive: true
}, {
  id: 2,
  time: "14:00 - 15:00",
  dj: "Sarah Jenkins",
  show: "Small Group Math",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680106/img/instructor_sarah.png",
  isLive: false
}, {
  id: 3,
  time: "16:00 - 17:30",
  dj: "Dr. Aris Thorne",
  show: "SAT Prep Workshop",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680106/img/instructor_aris.png",
  isLive: false
}, {
  id: 4,
  time: "18:00 - 19:00",
  dj: "Marcus Chen",
  show: "Physics Lab Review",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680106/img/instructor_marcus.png",
  isLive: false
}];
const waveformHeights = [20, 45, 75, 30, 90, 50, 80, 100, 60, 40, 85, 30, 70, 50, 95, 40, 60, 80, 30, 50, 25, 65, 85, 40, 70, 90, 55, 35, 75, 100, 45, 80, 60, 30, 95, 50, 70, 40, 85, 20];
export default function CalendarBooking() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}